import { createReducer } from 'actionware';
import { fetchSummary, fetchInvestmentDetail } from './lenderStatisticActions';
import { createState } from 'stateware';

const initialState = createState({
  summary: {},
  investmentDetail: {},
  totalLoans({ summary }) {
    return summary['active_loans'] + summary['fully_paid_loans']
  },
  investmentPercentage({ summary }) {
    const disbursedAmount = Number(summary['disbursed_amount'])
    const balance = Number(summary['total_balance'])
    return (disbursedAmount / (disbursedAmount + balance)) * 100
  }
});

export default createReducer(initialState)
  .on(fetchSummary, (state, summary) =>
    initialState.copy({ ...state, summary })
  )
  .on(fetchInvestmentDetail, (state, investment) => {
    return initialState.copy({ ...state, investmentDetail: investment })
  })
